import { configureStore } from "@reduxjs/toolkit";
 import upSwapSlice from './slice/upSwapSlice'
import customerServices from "./service/customerServices";
import vendorService from "./service/vendorService";
import loginService from "./service/loginService";

export const store = configureStore({
  reducer: {
    upSwap: upSwapSlice,
     [customerServices.reducerPath]: customerServices.reducer, 
     [vendorService.reducerPath]: vendorService.reducer, 
      [loginService.reducerPath]: loginService.reducer,

  }, 
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
       customerServices.middleware , vendorService.middleware , loginService.middleware
    ),
});

